<template>
  <v-app>
    <div
      style="position: fixed; height: 100vh; width: 100vw; background-color: #e7f0dd !important"
    />
    <v-container
      id="fundo"
      class="p-0 fill-height"
      fluid
    >
      <v-row
        class="fill-height"
        align="center"
        justify="center"
      >
        <v-col
          cols="11"
          sm="8"
          md="5"
          lg="4"
          xl="3"
          style="padding: 0px"
        >
          <v-container :style="$vuetify.breakpoint.xs ? 'padding: 4px' : ''">
            <v-container class="pb-4">
              <v-row
                class="layout-logos-login fill-height px-4 height"
                align="center"
                justify="center"
              >
                <v-img
                  class="logo-form-login"
                  src="@/assets/logo_branca.png"
                  height="200px"
                  contain
                />
              </v-row>
            </v-container>
            <v-card
              color="white"
              style="padding: 12px"
            >
              <div style="width: 100%; text-align: center">
                <span
                  style="font-size: 16px; text-align: center; font-weight: 500"
                >Redefinir Senha</span>
              </div>
              <div v-if="!loader">
                <v-form
                  id="form_login"
                  ref="form"
                  v-model="valid"
                  @submit.prevent="send"
                >
                  <v-container class="pa-4">
                    <v-row dense>
                      <v-col
                        cols="12"
                        class="pt-0 mb-0 pb-0"
                      >
                        <h3
                          style="text-align: left;
                     line-height: normal;
                     margin: 0px;
                     color: rgb(102, 102, 102);"
                        >
                          Requisitos de senha
                        </h3>
                        <p
                          style="color: #808080;"
                          class="mb-0 text-subtitle-1"
                        >
                          Por favor, siga este guia para uma senha forte:
                        </p>
                        <li
                          :style="`font-size: 13px !important;font-weight: bold; color: ${ upDow ? '#4CAF50' : '#808080' }`"
                          class="mb-0 text-subtitle-1"
                        >
                          <span>
                            Use letras maiúscula e minúsculas
                            <v-icon
                              v-if="upDow"
                              small
                              color="#4CAF50"
                            >
                              mdi-check-bold
                            </v-icon>
                          </span>
                        </li>
                        <li
                          :style="`font-size: 13px !important;font-weight: bold; color: ${ carNum ? '#4CAF50' : '#808080' }`"
                          class="mb-0 text-subtitle-1"
                        >
                          <span>
                            Um número (2 são recomendados)
                            <v-icon
                              v-if="carNum"
                              small
                              color="#4CAF50"
                            >
                              mdi-check-bold
                            </v-icon>
                          </span>
                        </li>
                        <li
                          :style="`font-size: 13px !important;font-weight: bold; color: ${ carEsp ? '#4CAF50' : '#808080' }`"
                          class="mb-0 text-subtitle-1"
                        >
                          <span>
                            Um caracter especial
                            <v-icon
                              v-if="carEsp"
                              small
                              color="#4CAF50"
                            >
                              mdi-check-bold
                            </v-icon>
                          </span>
                        </li>
                        <li
                          :style="`font-size: 13px !important;font-weight: bold; color: ${ minCar ? '#4CAF50' : '#808080' }`"
                          class="mb-0 text-subtitle-1"
                        >
                          <span>
                            Mínimo de 8 caracteres
                            <v-icon
                              v-if="minCar"
                              small
                              color="#4CAF50"
                            >
                              mdi-check-bold
                            </v-icon>

                          </span>
                        </li>
                      </v-col>
                      <v-col
                        cols="12"
                        md="12"
                      >
                        <v-text-field
                          v-model="newPassword"
                          outlined
                          rounded
                          :append-icon="show ? 'mdi-eye' : 'mdi-eye-off'"
                          :rules="[
                            rules.required,
                            rules.minLength(minLength, `Mínimo ${minLength} caracteres.`),
                          ]"
                          :type="show ? 'text' : 'password'"
                          label="Senha"
                          validate-on-blur
                          autocomplete="new-password"
                          @click:append="show = !show"
                          @keyup="validaSenha"
                        />
                      </v-col>
                      <v-col
                        cols="12"
                        md="12"
                      >
                        <v-text-field
                          v-model="passwordConfirm"
                          outlined
                          rounded
                          :append-icon="showConfirmation ? 'mdi-eye' : 'mdi-eye-off'"
                          :rules="[
                            rules.required,
                            rules.minLength(minLength, `Mínimo ${minLength} caracteres.`),
                            senhasIguais,
                          ]"
                          :type="showConfirmation ? 'text' : 'password'"
                          label="Confirmação de senha"
                          validate-on-blur
                          autocomplete="new-password"
                          counter
                          @click:append="showConfirmation = !showConfirmation"
                        />
                      </v-col>
                    </v-row>
                    <v-row
                      justify="center"
                      class="pt-2 mt-4"
                    >
                      <v-btn
                        class="text-none text-white"
                        color="success"
                        type="submit"
                      >
                        <span style="font-weight: 600">Redefinir Senha</span>
                      </v-btn>
                    </v-row>
                  </v-container>
                </v-form>
              </div>
            </v-card>
          </v-container>
        </v-col>
      </v-row>
    </v-container>
  </v-app>
</template>
<script>
  import rules from '../../utils/formRules'
  export default {
    data () {
      return {
        loader: false,
        valid: null,
        show: false,
        minLength: 8,
        showConfirmation: false,
        newPassword: '',
        passwordConfirm: '',
        name: null,
        upDow: false,
        carEsp: false,
        carNum: false,
        minCar: false,
        rules,
      }
    },
    created () {
      // createFormFields({
      //   create: true,
      //   fields: this.fields,
      //   store: this.$store,
      //   module: 'form',
      // })
      this.api.verifyToken(this.$route.params.token).then(
        result => {
        },
        error => {
          this.Swal.close()
          this.Swal.fire({
            icon: 'error',
            title: 'Token inválido!',
            text: 'Por favor, solicite a alteração de senha novamente.',
            showConfirmButton: true,
          }).then(a => {
            this.$router.push({ path: '/login' })
          })
          console.error(error)
        },
      )
    },
    methods: {
      send () {
        const newPassword = this.newPassword
        const passwordConfirm = this.passwordConfirm
        if (this.$refs.form.validate()) {
          this.Swal.fire({
            title: 'Alterando Senha!',
            timerProgressBar: true,
            showConfirmButton: false,
            willOpen: () => {
              this.Swal.showLoading()
            },
            didOpen: () => {
              const form = {
                newPassword,
                passwordConfirm,
              }
              this.api.resetPassword(form, this.$route.params.token).then(
                result => {
                  this.Swal.fire({
                    icon: 'success',
                    title: 'Senha alterada com sucesso!',
                    showConfirmButton: false,
                    timer: 2000,
                  })
                  this.$router.push({ path: '/login' })
                },
                error => {
                  this.Swal.close()
                  this.Swal.fire({
                    icon: 'error',
                    title: 'Ocorreu um erro!',
                    text: 'Por favor solicite a alteração de senha novamente.',
                    showConfirmButton: true,
                  })
                  console.error(error)
                },
              )
            },
          })
          this.$router.push({ path: '/' })
        }
      },
      validaSenha (evento) {
        const value = evento.target.value
        if ((/[a-z]/gm.test(value)) && (/[A-Z]/gm.test(value))) {
          this.upDow = true
        } else {
          this.upDow = false
        }
        if (/[0-9]/gm.test(value)) {
          this.carNum = true
        } else {
          this.carNum = false
        }
        if (/[!@#$%*()_+^&{}}:;?.]/gm.test(value)) {
          this.carEsp = true
        } else {
          this.carEsp = false
        }
        if (value.length >= 8) {
          this.minCar = true
        } else {
          this.minCar = false
        }
      },
      senhasIguais (v) {
        return v === this.newPassword || 'As senhas não coincidem'
      },
    },
  }
</script>
